import { LimitAuthenticationModal } from './LimitAuthenticationModal'
import { withLimitAuthenticationModal } from './withLimitAuthenticationModal'

const ConnectedLimitAuthenticationModal = withLimitAuthenticationModal(
  LimitAuthenticationModal
)

export { ConnectedLimitAuthenticationModal as LimitAuthenticationModal }
